










import { Component, Vue } from 'vue-property-decorator';
import Footer from "@/components/base/Footer.vue";
import Header from "@/components/base/Header.vue";

@Component({
  components: {Header, Footer},
})
export default class Default extends Vue{
}
